// jQuery
import 'jquery'

// Semantic UI
import './semantic/semantic'

// Hammer.js
import 'hammerjs'



//////////////////
// WEBPACK FOOTER
// ./vendor/index.js
// module id = 118
// module chunks = 0